// Transparent Header Logic for Hero Media Background
// This script ensures that when the hero-media-background section has transparency enabled and is the first section on the page
// the gaia-header becomes transparent and overlays the hero. It also handles scroll and resize events to toggle the class.

document.addEventListener("DOMContentLoaded", function () {
  // Get the hero section and header
  const heroSection = document.querySelector(
    ".banner.top-section.transparent-header",
  );
  const gaiaHeader = document.querySelector("gaia-header");

  // If either is missing, exit
  if (!heroSection || !gaiaHeader) {
    // Remove class just in case
    if (gaiaHeader) gaiaHeader.classList.remove("transparent-header");
    return;
  }

  // Function to get the current header height (including announcement bar)
  function getHeaderHeight() {
    // Uses the CSS variable set by the header
    const headerHeight = getComputedStyle(
      document.documentElement,
    ).getPropertyValue("--header-height");
    return parseInt(headerHeight) || 0;
  }

  // Function to add or remove the transparent-header class based on scroll position
  function updateHeaderTransparency() {
    const scrollY = window.scrollY || window.pageYOffset;
    const headerHeight = getHeaderHeight();
    if (scrollY <= headerHeight) {
      heroSection.classList.add("transparent-header");
      gaiaHeader.classList.add("transparent-header");
    } else {
      heroSection.classList.remove("transparent-header");
      gaiaHeader.classList.remove("transparent-header");
    }
  }

  // Initial state
  updateHeaderTransparency();

  // Listen for scroll and resize events
  window.addEventListener("scroll", updateHeaderTransparency, {
    passive: true,
  });
  window.addEventListener("resize", function () {
    // Timeout to wait for header height recalculation
    setTimeout(updateHeaderTransparency, 50);
  });

  // Also listen for custom event in case header height is recalculated by other scripts
  document.addEventListener("headerHeightChanged", updateHeaderTransparency);
});
